import { Plugin } from './Plugin';
import { range } from 'libs';
import { Vector2 } from 'three';

export class MousePlugin extends Plugin{
	constructor(manager){
		super(manager);

		this.position 	= new Vector2();
		this.speed 		= new Vector2();
		this.start 		= new Vector2();
		this.end	 	= new Vector2();

		this.bounds 		= this.viewer.domElement.getBoundingClientRect();
		this.resizeObserver = new ResizeObserver(this.onResize);
	}

	attach(helper, model){
		this.resizeObserver.observe(this.viewer.domElement);

		window.addEventListener( 'mousemove', this.onMove);
		window.addEventListener( 'touchmove', this.onMove, {passive:false});

		this.viewer.domElement.addEventListener('mousedown', this.onDown);
		this.viewer.domElement.addEventListener('touchstart', this.onDown, {passive:false});

		this.viewer.domElement.addEventListener('mouseover', this.onHover);
		this.viewer.domElement.addEventListener('mouseleave', this.onLeave);
	}

	detach(){
		this.resizeObserver.unobserve(this.viewer.domElement);

		window.removeEventListener( 'mousemove', this.onMove, {passive:false});
		window.removeEventListener( 'touchmove', this.onMove);

		window.removeEventListener('mouseup', this.onUp);
		window.removeEventListener('touchend', this.onUp, {passive:false});

		this.viewer.domElement.removeEventListener('mousedown', this.onDown);
		this.viewer.domElement.removeEventListener('touchstart', this.onDown, {passive:false});

		this.viewer.domElement.removeEventListener('mouseover', this.onHover);
		this.viewer.domElement.removeEventListener('mouseleave', this.onLeave);
	}

	onHover = () => {
		this.emit('hover');
	}

	onLeave = () => {
		this.emit('leave');
	}

	onResize = (entries) => {
		for (let entry of entries) {
			this.bounds = entry.contentRect;
		}
	}

	onMove = (e) => {
		this.speed.copy(this.position);
		this.updateMouse(e);
		this.speed.sub(this.position).negate();

		this.emit('move', e);
	}

	onDown = (e) => {
		window.addEventListener('mouseup', this.onUp);
		window.addEventListener('touchend', this.onUp, {passive:false});

		this.updateMouse(e);
		this.start.copy(this.position);

		this.emit('down', e);
	}

	onUp = (e) => {
		window.removeEventListener('mouseup', this.onUp);
		window.removeEventListener('touchend', this.onUp, {passive:false});

		this.updateMouse(e);
		this.end.copy(this.position);
		this.speed.set(0,0);

		this.emit('up', e);
	}

	updateMouse(e){
		if(e.clientX && e.clientY){
			this.position.set(
				range(this.bounds.left, this.bounds.right, -1, 1, e.clientX),
				range(this.bounds.top, this.bounds.bottom, 1, -1, e.clientY)
			);
		}
		else if(e.changedTouches && e.changedTouches.length) {
			this.position.set(
				range(this.bounds.left, this.bounds.right, -1, 1, e.changedTouches[0].clientX),
				range(this.bounds.top, this.bounds.bottom, 1, -1, e.changedTouches[0].clientY)
			);
		}
	}
}